function getAccountType() {
  return localStorage.getItem('Account_type')
}

export default getAccountType



// WEBPACK FOOTER //
// ./src/utils/getAccountType.js